(function($) {
    function initActiveScrollSelector() {
        if ($(".timeline-change").length > 0) {
            var minusHeight = $(".timeline-change").outerHeight() + $("header").outerHeight();
            $(window).on("scroll", function() {
                var scroll = $(window).scrollTop();

                var activeSelector = $('section');
                var nav = $('.timeline-change ul');

                activeSelector.each(function() {
                    var top = $(this).offset().top - minusHeight - 100,
                        bottom = top + $(this).outerHeight();
                    if (scroll >= top && scroll <= bottom) {
                        nav.find('li.active').siblings('li.active').removeClass('active');
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li").addClass("active");
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li.active").clone().appendTo(".mobile-nav");
                    } else if (scroll >= bottom) {
                        nav.find("li.active").removeClass("active");
                    }
                });
            });
        }
    }

    $(document).ready(function() {
        $(".click-more").click(function(e) {
            // Close all open windows
            e.preventDefault();
            $(this).toggleClass("active");
            $(this).parent().parent().find(".expend-item").stop().slideToggle(300);
        });
        if ((".banner-second-level").length > 0) {
            $('.banner-second-level .btn-wrap .explore').on('click', function(e) {
                e.preventDefault();
                var href = $(this).attr('href');
                $('html, body').animate({
                    scrollTop: $(href).offset().top
                }, 500);
            });
        }
        if ($(".timeline-change").length > 0) {
            initActiveScrollSelector();
            setTimeout(function() {
                $(".timeline-change").css("opacity", "1");
            }, 500);
        }
        $(".collapse-event a").click(function(e) {
            e.preventDefault();
            if ($(this).text() == "Expand all Events") {
                $(this).text("Collapse All Events")
            } else {
                $(this).text("Expand all Events")
            }
            $(".collapse").toggleClass("rotate-arrow");
            $(".collapse .text-wrap").stop(true, true).slideToggle(500);
        });
        $(".collapse-btn").on("click", function(e) {
            e.preventDefault();
            var windowWidth = $(window).width();
            if ($(this).parent().hasClass('rotate-arrow')) {
                $(this).parent().removeClass('rotate-arrow');
                $(this).parent().find(".text-wrap").stop(true, true).slideUp(500);
            } else {
                // Hide the other panels
                $(this).parent().addClass('rotate-arrow');
                $(this).parent().find(".text-wrap").stop(true, true).slideDown(500);
            }
        });
    });

    function scrollTop() {
        if ($(this).scrollTop() > 1000) {
            $('.up').addClass('show').removeClass('hide');
        } else {
            $('.up').removeClass('show').addClass('hide');
            $('.up').removeClass('hide-btn');
        }
    }

    function set_scrollTop() {
        if ($('footer').length > 0) {
            var footer_offset = $('footer  .container').offset().left;
            var row_width = $('footer .row').width();
            var we_total = footer_offset + row_width - 35;
            $('.up').css('left', we_total + 'px');
            var footer_height = $('footer').outerHeight() - 25 + 'px';
            $('.up').css('bottom', footer_height);
        }
    }
    $(document).ready(function() {
        if ($('.up').length > 0) {
            set_scrollTop();
        }
        scrollTop();
        $(document).on('click', '.up', function() {
            $('html, body').animate({ 'scrollTop': "0" }, 800);
            $('.up').addClass('hide-btn');
        });
    });

    $(window).on('resize', function() {
        if ($('.up').length > 0) {
            set_scrollTop();
        }
    });

    $(window).on('load', function() {
        if ($('.up').length > 0) {
            set_scrollTop();
        }
    });

    $(window).on("scroll", function() {
        scrollTop();
    });

    $(document).ready(function() {
        $(document).on('click', '.video-active', function(e) {
            e.preventDefault();
            var linkval = $(this).attr('data-video');
            $(".video-overlay").addClass("active");
            $('body').css("overflow", "hidden");
            $('.video-overlay .video-container > iframe').attr("src", linkval + "?autoplay=1");
            
            $('.video-overlay').css({ 'display': '1', 'visibility': 'visible' });
        });

        $(document).on('click', '.video-overlay .closeVideo', '.video-overlay', function(e) {
            $('.video-overlay').removeClass('active');
            $('.video-overlay').css({ 'display': '0', 'visibility': 'hidden' });
            $('body').css("overflow", "inherit");
            $('.video-overlay iframe').attr("src", "");
        });

        $(document).on('click', '.video-overlay', function(e) {
            $('.video-overlay').removeClass('active');
            $('.video-overlay').css({ 'display': '0', 'visibility': 'hidden' });
            $('body').css("overflow", "inherit");
            $('.video-overlay iframe').attr("src", "");
        });
    });

})(jQuery);